import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { Crown, Loader2, Eye, EyeOff } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { useLogo } from "../App";

const ADMIN_API = process.env.REACT_APP_BACKEND_URL + '/api';

const SaaSAdminLoginPage = () => {
  const navigate = useNavigate();
  const { logoUrl } = useLogo();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("メールアドレスとパスワードを入力してください");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`${ADMIN_API}/admin/login`, { email, password });
      localStorage.setItem("admin_token", res.data.token);
      localStorage.setItem("admin_user", JSON.stringify(res.data.admin));
      toast.success(`ようこそ、${res.data.admin.name}さん`);
      navigate("/saas-admin");
    } catch (error) {
      toast.error(error.response?.data?.detail || "ログインに失敗しました");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-slate-800 border-slate-700">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-slate-700 to-slate-800 flex items-center justify-center overflow-hidden border-2 border-amber-500">
              <img src={logoUrl} alt="PRC勤怠" className="w-12 h-12 object-contain" />
            </div>
          </div>
          <CardTitle className="text-2xl font-bold text-white">
            SaaS管理コンソール
          </CardTitle>
          <CardDescription className="text-slate-400">
            管理者アカウントでログイン
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            <div className="space-y-2">
              <Label className="text-slate-300">メールアドレス</Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@example.com"
                className="bg-slate-700 border-slate-600 text-white placeholder:text-slate-400"
                data-testid="admin-email-input"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-slate-300">パスワード</Label>
              <div className="relative">
                <Input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="bg-slate-700 border-slate-600 text-white placeholder:text-slate-400 pr-10"
                  data-testid="admin-password-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-slate-400 hover:text-white"
                >
                  {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-yellow-500 to-amber-600 hover:from-yellow-600 hover:to-amber-700 text-white"
              data-testid="admin-login-btn"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
              ログイン
            </Button>
          </form>
          <div className="mt-6 text-center">
            <a href="/" className="text-sm text-slate-400 hover:text-slate-300">
              ← ユーザーサイトへ戻る
            </a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SaaSAdminLoginPage;
